import {useContext} from "react";
import {SearchOptionsContext} from "../../../context/search-options-context";
import {AuthContext} from "../../../context/auth-context";
import ReserveOffer from "../components/ReserveOffer";
import CancelReservation from "../components/CancelReservation";
import { Typography } from '@material-ui/core';

const OfferState = ({offer, onChange}) => {

  const searchOptions = useContext(SearchOptionsContext);
  const authContext = useContext(AuthContext);

  const isUserOwner =  authContext.user.code === offer.ownerCode;
  const isReserved =  offer.state === "RESERVED";
  const showReservationCancel = isUserOwner && isReserved;

  return (
    <>
      {searchOptions.offerState[offer.state]}
      <br/>
      { !isUserOwner && <ReserveOffer offer={offer} onChange={onChange}/>}
      { showReservationCancel && <CancelReservation offer={offer} onChange={onChange}/>}
      {offer.offerOfMonth &&  authContext.user.roles.includes("ROLE_ADMIN") && <Typography color="primary" style={{ color: '#4caf50' }}>Oferta miesiąca</Typography>}
    </>);
}


export default OfferState;
